class ApiTimeoutError extends Error {
  constructor() {
    super('Request timed out');
    this.name = 'ApiTimeoutError';
  }
}

// Client timeout occurs after 60 secs without a response, so we'll do 59 to be safe
const defaultTimeout = 59000;

export const timeoutPromise = async (
  apiRequest: () => Promise<Response | void>,
  timeoutCallback: () => void,
  timeoutOverride?: number,
) =>
  new Promise((resolve, reject) => {
    const timeoutId = setTimeout(
      () => reject(new ApiTimeoutError()),
      timeoutOverride || defaultTimeout,
    );
    apiRequest()
      .then((data) => resolve(data))
      .catch((err) => reject(err))
      .finally(() => clearTimeout(timeoutId));
  }).catch((err) => {
    if (timeoutCallback && err instanceof ApiTimeoutError) {
      timeoutCallback();
    }
  });
